import axios from "axios";
import { baseUrl } from "../../../config/app.config.js";

export const InsertNotificationContactInfo = async ContactInfo => {
  try {
    var response = await axios({
      method: "POST",
      url: baseUrl + "/api/reports/InsertNotificationContactInfo",
      data: ContactInfo
    });
  } catch (e) {
    response = "Something went wrong";
  }

  return response;
};
